import { render, staticRenderFns } from "./KOLAdOrderRank.vue?vue&type=template&id=60479342&scoped=true"
import script from "./KOLAdOrderRank.vue?vue&type=script&lang=js"
export * from "./KOLAdOrderRank.vue?vue&type=script&lang=js"
import style0 from "./KOLAdOrderRank.vue?vue&type=style&index=0&id=60479342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60479342",
  null
  
)

export default component.exports